import { FC } from 'react';
import { Box, Avatar, Divider, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import { SCUIGeneralModal } from '../../../atomic/molecules';
import { LCRD } from '../lostCargoReturnDetailPage.classes';

export const LostCargoReturnDetailModalApprove: FC<{
    product: any;
    open: any;
    onClose?: any;
    returnData: any;
    formattedCreateConfirm?: any;
    onSave?: (updatedProduct: any) => void;
}> = ({ product, open, onClose, returnData, onSave }) => {
    const { t } = useTranslation();

    const handleRestockQuantity = (event: any) => {
        const selectedRestockQuantity = Number(event.target.value);
        const remainingQuantity = product.piece - selectedRestockQuantity;

        const updatedProduct = {
            ...product,
            restockQuantity: selectedRestockQuantity,
            nonRestockQuantity: remainingQuantity,
        };
        if (onSave) {
            onSave(updatedProduct);
        }
    };

    const handleNonRestockQuantity = (event: any) => {
        const selectedNonRestockQuantity = Number(event.target.value);
        const remainingQuantity = product.piece - selectedNonRestockQuantity;

        const updatedProduct = {
            ...product,
            nonRestockQuantity: selectedNonRestockQuantity,
            restockQuantity: remainingQuantity,
        };
        if (onSave) {
            onSave(updatedProduct);
        }
    };

    let quantityForSelectBox: any = [];
    for (let i = 0; i <= product.piece; i++) {
        quantityForSelectBox.push(<MenuItem value={i}>{i}</MenuItem>);
    }

    return (
        <SCUIGeneralModal
            autoFocusButton={true}
            open={open}
            onClose={onClose}
            width={'sm'}
            sx={{
                '& .MuiDialogTitle-root': {
                    fontSize: '16px !important',
                    fontWeight: '700',
                    padding: '0 !important',
                },
                '& .MuiDialog-paper': {
                    padding: '24px',
                },
            }}
            title={t('general.productApproval')}
            functionButtonOnClick={onClose}
            buttonText={t('general.save')}
        >
            <Box className={LCRD.approveModalBody} sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box className={LCRD.approveModalProductSection}>
                    <p style={{ fontSize: '16px', fontWeight: '700' }}>{t('return.productInfo')}</p>
                </Box>
                <Box sx={{ padding: '1rem', display: 'flex', flexDirection: 'row' }}>
                    <Box sx={{ marginRight: '16px' }}>
                        <Avatar
                            sx={{
                                width: 128,
                                height: 128,
                                display: 'inline-block',
                                verticalAlign: 'top',
                                '& .MuiAvatar-img': {
                                    objectFit: 'contain !important',
                                },
                            }}
                            variant="square"
                            src={product.productImageUrl}
                        />
                    </Box>
                    <Box>
                        <p style={{ fontSize: '14px', fontWeight: '700' }}>{t('general.returnReason')}</p>
                        {product.reason === 15 ||
                        product.reason === 9 ||
                        product.reason === 3 ||
                        product.reason === 44 ? (
                            <p
                                style={{
                                    fontSize: '14px',
                                    fontWeight: '700',
                                    backgroundColor: 'red',
                                    paddingLeft: '2px',
                                }}
                            >
                                {product.reasonDescription}
                            </p>
                        ) : (
                            <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.reasonDescription}</p>
                        )}
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.productName')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.productDescriptionOnWebSite}</p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.productSize')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.size}</p>
                    </Box>
                    <Box sx={{ marginLeft: '24px' }}>
                        <p style={{ fontSize: '14px', fontWeight: '700' }}> {t('general.barcode')}</p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.barcode}</p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.specialCode')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>
                            {product.ozelKod1} - {product.renkKod}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '700', marginTop: '6px' }}>
                            {t('general.brandName')}
                        </p>
                        <p style={{ fontSize: '14px', fontWeight: '400' }}>{product.brandName}</p>
                    </Box>
                </Box>
                <Divider sx={{ paddingTop: 2, marginBottom: 2, width: '100%' }} />
                <Box className={LCRD.approveModalQuantitySection} sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <CheckCircleOutlineIcon
                                sx={{ width: '20px', height: '20px', marginRight: '8px' }}
                                color="success"
                            />
                            <p style={{ fontSize: '16px', fontWeight: '700' }}>{t('return.returnAccept')}</p>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.restockQuantity')}</InputLabel>
                                <Select
                                    className={LCRD.inputSelectApproveRestock}
                                    disabled={!product.isReturnable || returnData.returnPlatformTypeId == 9}
                                    fullWidth
                                    label={t('general.restockQuantity')}
                                    value={product.restockQuantity}
                                    onChange={handleRestockQuantity}
                                >
                                    {quantityForSelectBox}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.nonRestockQuantity')}</InputLabel>
                                <Select
                                    className={LCRD.inputSelectApproveNonRestock}
                                    disabled={!product.isReturnable || returnData.returnPlatformTypeId == 9}
                                    fullWidth
                                    label={t('general.nonRestockQuantity')}
                                    value={product.nonRestockQuantity}
                                    onChange={handleNonRestockQuantity}
                                >
                                    {quantityForSelectBox}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box sx={{ marginTop: '16px' }}>
                            <FormControl fullWidth>
                                <InputLabel>{t('general.operatorReturnReason')}</InputLabel>
                                <Select
                                    className={LCRD.inputSelectApproveOperatorReason}
                                    disabled={true}
                                    fullWidth
                                    label={t('general.operatorReturnReason')}
                                    value={product.reasonDescription}
                                >
                                    {
                                        <MenuItem
                                            key={product.reasonDescription}
                                            value={product.reasonDescription}
                                            selected={product.reasonDescription}
                                        >
                                            {product.reasonDescription}
                                        </MenuItem>
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
                <Divider sx={{ paddingTop: 2, width: '100%' }} />
            </Box>
        </SCUIGeneralModal>
    );
};
